"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = surveySaga;
var _effects = require("redux-saga/effects");
var _survey = require("./survey.action");
var _survey2 = require("./survey.constant");
var _services = require("../../../../services");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(surveySaga);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function surveyList(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _payload, _payload$fkUserIdList, _payload2, _payload2$fkUserIdLis, _payload3, _payload4, _payload5, _payload5$colIsApprov, _payload7, _payload7$colIsEdited, _payload9, _payload9$colIsActive, _payload10, _payload11, _payload11$yearList, _payload12, _payload12$yearList, _payload13, _payload13$tags, _response$data, filter, _payload6, approvedAdmin, _payload8, isEditedCase, _payload14, _payload14$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          filter = {}; // Owner
          if ((_payload = payload) !== null && _payload !== void 0 && (_payload$fkUserIdList = _payload.fkUserIdList) !== null && _payload$fkUserIdList !== void 0 && _payload$fkUserIdList.value) filter["fkUserIdList"] = (_payload2 = payload) === null || _payload2 === void 0 ? void 0 : (_payload2$fkUserIdLis = _payload2.fkUserIdList) === null || _payload2$fkUserIdLis === void 0 ? void 0 : _payload2$fkUserIdLis.value;else if (Array.isArray((_payload3 = payload) === null || _payload3 === void 0 ? void 0 : _payload3.fkUserIdList)) filter["fkUserIdList"] = (_payload4 = payload) === null || _payload4 === void 0 ? void 0 : _payload4.fkUserIdList;

          // Approved

          if (((_payload5 = payload) === null || _payload5 === void 0 ? void 0 : (_payload5$colIsApprov = _payload5.colIsApproved) === null || _payload5$colIsApprov === void 0 ? void 0 : _payload5$colIsApprov.length) > 0) {
            approvedAdmin = (_payload6 = payload) === null || _payload6 === void 0 ? void 0 : _payload6.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload7 = payload) === null || _payload7 === void 0 ? void 0 : (_payload7$colIsEdited = _payload7.colIsEdited) === null || _payload7$colIsEdited === void 0 ? void 0 : _payload7$colIsEdited.length) > 0) {
            isEditedCase = (_payload8 = payload) === null || _payload8 === void 0 ? void 0 : _payload8.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload9 = payload) === null || _payload9 === void 0 ? void 0 : (_payload9$colIsActive = _payload9.colIsActive) === null || _payload9$colIsActive === void 0 ? void 0 : _payload9$colIsActive.length) === 1) filter["colIsActive"] = (_payload10 = payload) === null || _payload10 === void 0 ? void 0 : _payload10.colIsActive[0];

          // Year
          if ((_payload11 = payload) !== null && _payload11 !== void 0 && (_payload11$yearList = _payload11.yearList) !== null && _payload11$yearList !== void 0 && _payload11$yearList.value) filter["colFiscalYear"] = (_payload12 = payload) === null || _payload12 === void 0 ? void 0 : (_payload12$yearList = _payload12.yearList) === null || _payload12$yearList === void 0 ? void 0 : _payload12$yearList.value;
          if (((_payload13 = payload) === null || _payload13 === void 0 ? void 0 : (_payload13$tags = _payload13.tags) === null || _payload13$tags === void 0 ? void 0 : _payload13$tags.length) > 0) {
            colTags = "";
            (_payload14 = payload) === null || _payload14 === void 0 ? void 0 : (_payload14$tags = _payload14.tags) === null || _payload14$tags === void 0 ? void 0 : _payload14$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.colIsApproved;
          delete payload.colIsEdited;
          delete payload.colIsActive;
          delete payload.yearList;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context.next = 18;
          return (0, _effects.call)(_services.surveyListApi, payload);
        case 18:
          response = _context.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 200)) {
            _context.next = 24;
            break;
          }
          _context.next = 22;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LIST, response === null || response === void 0 ? void 0 : response.data));
        case 22:
          _context.next = 26;
          break;
        case 24:
          _context.next = 26;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LIST, response === null || response === void 0 ? void 0 : response.data));
        case 26:
          _context.next = 32;
          break;
        case 28:
          _context.prev = 28;
          _context.t0 = _context["catch"](0);
          _context.next = 32;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LIST, _context.t0));
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 28]]);
  })();
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function surveyFetch(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _response$data2, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.surveyFetchApi, payload);
        case 3:
          response = _context2.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === 200)) {
            _context2.next = 9;
            break;
          }
          _context2.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.FETCH, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context2.next = 11;
          break;
        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context2.next = 17;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH, _context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function surveyFetchPasscode(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data3, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.surveyFetchPasscodeApi, payload);
        case 3:
          response = _context3.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 200)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.FETCH_PASSCODE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH_PASSCODE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH_PASSCODE, _context3.t0));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function surveyGetSurveyPasscode(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data4, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.surveyFetchPasscodeApi, payload);
        case 3:
          response = _context4.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 200)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.GET_SURVEY_PASSCODE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context4.next = 11;
          break;
        case 9:
          _context4.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.GET_SURVEY_PASSCODE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context4.next = 17;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.GET_SURVEY_PASSCODE, _context4.t0));
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
function surveyCreate(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _response$data5, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.surveyCreateApi, payload);
        case 3:
          response = _context5.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.code) === 201)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.CREATE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.CREATE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context5.next = 17;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.CREATE, _context5.t0));
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 13]]);
  })();
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
function surveyUpdate(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _response$data6, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.surveyUpdateApi, payload);
        case 3:
          response = _context6.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 202)) {
            _context6.next = 9;
            break;
          }
          _context6.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context6.next = 11;
          break;
        case 9:
          _context6.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context6.next = 17;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UPDATE, _context6.t0));
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
function surveyUpdateDetail(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _response$data7, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.surveyUpdateApi, payload);
        case 3:
          response = _context7.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.code) === 202)) {
            _context7.next = 9;
            break;
          }
          _context7.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.UPDATE_DETAIL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context7.next = 11;
          break;
        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UPDATE_DETAIL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context7.next = 17;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UPDATE_DETAIL, _context7.t0));
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 13]]);
  })();
}

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
function surveyLinkedFund(_ref8) {
  var payload = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _response$data8, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.surveyLinkedFundApi, payload);
        case 3:
          response = _context8.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.code) === 200)) {
            _context8.next = 9;
            break;
          }
          _context8.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context8.next = 11;
          break;
        case 9:
          _context8.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context8.next = 17;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LINKED_FUND, _context8.t0));
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 13]]);
  })();
}

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
function surveySaveLinkedFund(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _response$data9, response;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.surveySaveLinkedFundApi, payload);
        case 3:
          response = _context9.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 201)) {
            _context9.next = 9;
            break;
          }
          _context9.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SAVE_LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context9.next = 11;
          break;
        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SAVE_LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context9.next = 17;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SAVE_LINKED_FUND, _context9.t0));
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 13]]);
  })();
}

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
function surveyLock(_ref10) {
  var payload = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _response$data10, response;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.surveyLockApi, payload);
        case 3:
          response = _context10.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.code) === 200)) {
            _context10.next = 9;
            break;
          }
          _context10.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context10.next = 11;
          break;
        case 9:
          _context10.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LOCK, _context10.t0));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 13]]);
  })();
}

/**
 * Lock Bulk
 * @param payload
 *  @returns api response
 * @description this function used to Lock Bulk.
 */
function surveyLockBulk(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _payload15, _payload15$filterCrit, _payload16, _payload16$filterCrit, _payload17, _payload17$filterCrit, _payload17$filterCrit2, _payload18, _payload18$filterCrit, _payload19, _payload19$filterCrit, _payload19$filterCrit2, _payload21, _payload21$filterCrit, _payload21$filterCrit2, _payload23, _payload23$filterCrit, _payload23$filterCrit2, _payload24, _payload24$filterCrit, _payload25, _payload25$filterCrit, _payload25$filterCrit2, _payload26, _payload26$filterCrit, _payload26$filterCrit2, _payload27, _payload27$filterCrit, _payload27$filterCrit2, _payload29, _response$data11, filter, _payload20, _payload20$filterCrit, approvedAdmin, _payload22, _payload22$filterCrit, isEditedCase, _payload28, _payload28$filterCrit, _payload28$filterCrit2, colTags, response;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          filter = {}; // Search Text
          if ((_payload15 = payload) !== null && _payload15 !== void 0 && (_payload15$filterCrit = _payload15.filterCriteria) !== null && _payload15$filterCrit !== void 0 && _payload15$filterCrit.searchText) filter["searchText"] = (_payload16 = payload) === null || _payload16 === void 0 ? void 0 : (_payload16$filterCrit = _payload16.filterCriteria) === null || _payload16$filterCrit === void 0 ? void 0 : _payload16$filterCrit.searchText;

          // Owner
          if ((_payload17 = payload) !== null && _payload17 !== void 0 && (_payload17$filterCrit = _payload17.filterCriteria) !== null && _payload17$filterCrit !== void 0 && (_payload17$filterCrit2 = _payload17$filterCrit.fkUserIdList) !== null && _payload17$filterCrit2 !== void 0 && _payload17$filterCrit2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload18 = payload) === null || _payload18 === void 0 ? void 0 : (_payload18$filterCrit = _payload18.filterCriteria) === null || _payload18$filterCrit === void 0 ? void 0 : _payload18$filterCrit.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload19 = payload) === null || _payload19 === void 0 ? void 0 : (_payload19$filterCrit = _payload19.filterCriteria) === null || _payload19$filterCrit === void 0 ? void 0 : (_payload19$filterCrit2 = _payload19$filterCrit.colIsApproved) === null || _payload19$filterCrit2 === void 0 ? void 0 : _payload19$filterCrit2.length) > 0) {
            approvedAdmin = (_payload20 = payload) === null || _payload20 === void 0 ? void 0 : (_payload20$filterCrit = _payload20.filterCriteria) === null || _payload20$filterCrit === void 0 ? void 0 : _payload20$filterCrit.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload21 = payload) === null || _payload21 === void 0 ? void 0 : (_payload21$filterCrit = _payload21.filterCriteria) === null || _payload21$filterCrit === void 0 ? void 0 : (_payload21$filterCrit2 = _payload21$filterCrit.colIsEdited) === null || _payload21$filterCrit2 === void 0 ? void 0 : _payload21$filterCrit2.length) > 0) {
            isEditedCase = (_payload22 = payload) === null || _payload22 === void 0 ? void 0 : (_payload22$filterCrit = _payload22.filterCriteria) === null || _payload22$filterCrit === void 0 ? void 0 : _payload22$filterCrit.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload23 = payload) === null || _payload23 === void 0 ? void 0 : (_payload23$filterCrit = _payload23.filterCriteria) === null || _payload23$filterCrit === void 0 ? void 0 : (_payload23$filterCrit2 = _payload23$filterCrit.colIsActive) === null || _payload23$filterCrit2 === void 0 ? void 0 : _payload23$filterCrit2.length) === 1) filter["colIsActive"] = (_payload24 = payload) === null || _payload24 === void 0 ? void 0 : (_payload24$filterCrit = _payload24.filterCriteria) === null || _payload24$filterCrit === void 0 ? void 0 : _payload24$filterCrit.colIsActive[0];

          // Year
          if ((_payload25 = payload) !== null && _payload25 !== void 0 && (_payload25$filterCrit = _payload25.filterCriteria) !== null && _payload25$filterCrit !== void 0 && (_payload25$filterCrit2 = _payload25$filterCrit.yearList) !== null && _payload25$filterCrit2 !== void 0 && _payload25$filterCrit2.value) filter["colFiscalYear"] = (_payload26 = payload) === null || _payload26 === void 0 ? void 0 : (_payload26$filterCrit = _payload26.filterCriteria) === null || _payload26$filterCrit === void 0 ? void 0 : (_payload26$filterCrit2 = _payload26$filterCrit.yearList) === null || _payload26$filterCrit2 === void 0 ? void 0 : _payload26$filterCrit2.value;

          // Tag
          if (((_payload27 = payload) === null || _payload27 === void 0 ? void 0 : (_payload27$filterCrit = _payload27.filterCriteria) === null || _payload27$filterCrit === void 0 ? void 0 : (_payload27$filterCrit2 = _payload27$filterCrit.tags) === null || _payload27$filterCrit2 === void 0 ? void 0 : _payload27$filterCrit2.length) > 0) {
            colTags = "";
            (_payload28 = payload) === null || _payload28 === void 0 ? void 0 : (_payload28$filterCrit = _payload28.filterCriteria) === null || _payload28$filterCrit === void 0 ? void 0 : (_payload28$filterCrit2 = _payload28$filterCrit.tags) === null || _payload28$filterCrit2 === void 0 ? void 0 : _payload28$filterCrit2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload29 = payload) === null || _payload29 === void 0 ? true : delete _payload29.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context11.next = 13;
          return (0, _effects.call)(_services.surveyLockBulkApi, payload);
        case 13:
          response = _context11.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.code) === 200)) {
            _context11.next = 19;
            break;
          }
          _context11.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 17:
          _context11.next = 21;
          break;
        case 19:
          _context11.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context11.next = 27;
          break;
        case 23:
          _context11.prev = 23;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LOCK_BULK, _context11.t0));
        case 27:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 23]]);
  })();
}

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
function surveyUnlock(_ref12) {
  var payload = _ref12.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _response$data12, response;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.surveyUnlockApi, payload);
        case 3:
          response = _context12.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.code) === 200)) {
            _context12.next = 9;
            break;
          }
          _context12.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context12.next = 11;
          break;
        case 9:
          _context12.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context12.next = 17;
          break;
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](0);
          _context12.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNLOCK, _context12.t0));
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 13]]);
  })();
}

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
function surveyUnlockBulk(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var _payload30, _payload30$filterCrit, _payload31, _payload31$filterCrit, _payload32, _payload32$filterCrit, _payload32$filterCrit2, _payload33, _payload33$filterCrit, _payload34, _payload34$filterCrit, _payload34$filterCrit2, _payload36, _payload36$filterCrit, _payload36$filterCrit2, _payload38, _payload38$filterCrit, _payload38$filterCrit2, _payload39, _payload39$filterCrit, _payload40, _payload40$filterCrit, _payload40$filterCrit2, _payload41, _payload41$filterCrit, _payload41$filterCrit2, _payload42, _payload42$filterCrit, _payload42$filterCrit2, _payload44, _response$data13, filter, _payload35, _payload35$filterCrit, approvedAdmin, _payload37, _payload37$filterCrit, isEditedCase, _payload43, _payload43$filterCrit, _payload43$filterCrit2, colTags, response;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          filter = {}; // Search Text
          if ((_payload30 = payload) !== null && _payload30 !== void 0 && (_payload30$filterCrit = _payload30.filterCriteria) !== null && _payload30$filterCrit !== void 0 && _payload30$filterCrit.searchText) filter["searchText"] = (_payload31 = payload) === null || _payload31 === void 0 ? void 0 : (_payload31$filterCrit = _payload31.filterCriteria) === null || _payload31$filterCrit === void 0 ? void 0 : _payload31$filterCrit.searchText;

          // Owner
          if ((_payload32 = payload) !== null && _payload32 !== void 0 && (_payload32$filterCrit = _payload32.filterCriteria) !== null && _payload32$filterCrit !== void 0 && (_payload32$filterCrit2 = _payload32$filterCrit.fkUserIdList) !== null && _payload32$filterCrit2 !== void 0 && _payload32$filterCrit2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload33 = payload) === null || _payload33 === void 0 ? void 0 : (_payload33$filterCrit = _payload33.filterCriteria) === null || _payload33$filterCrit === void 0 ? void 0 : _payload33$filterCrit.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload34 = payload) === null || _payload34 === void 0 ? void 0 : (_payload34$filterCrit = _payload34.filterCriteria) === null || _payload34$filterCrit === void 0 ? void 0 : (_payload34$filterCrit2 = _payload34$filterCrit.colIsApproved) === null || _payload34$filterCrit2 === void 0 ? void 0 : _payload34$filterCrit2.length) > 0) {
            approvedAdmin = (_payload35 = payload) === null || _payload35 === void 0 ? void 0 : (_payload35$filterCrit = _payload35.filterCriteria) === null || _payload35$filterCrit === void 0 ? void 0 : _payload35$filterCrit.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload36 = payload) === null || _payload36 === void 0 ? void 0 : (_payload36$filterCrit = _payload36.filterCriteria) === null || _payload36$filterCrit === void 0 ? void 0 : (_payload36$filterCrit2 = _payload36$filterCrit.colIsEdited) === null || _payload36$filterCrit2 === void 0 ? void 0 : _payload36$filterCrit2.length) > 0) {
            isEditedCase = (_payload37 = payload) === null || _payload37 === void 0 ? void 0 : (_payload37$filterCrit = _payload37.filterCriteria) === null || _payload37$filterCrit === void 0 ? void 0 : _payload37$filterCrit.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload38 = payload) === null || _payload38 === void 0 ? void 0 : (_payload38$filterCrit = _payload38.filterCriteria) === null || _payload38$filterCrit === void 0 ? void 0 : (_payload38$filterCrit2 = _payload38$filterCrit.colIsActive) === null || _payload38$filterCrit2 === void 0 ? void 0 : _payload38$filterCrit2.length) === 1) filter["colIsActive"] = (_payload39 = payload) === null || _payload39 === void 0 ? void 0 : (_payload39$filterCrit = _payload39.filterCriteria) === null || _payload39$filterCrit === void 0 ? void 0 : _payload39$filterCrit.colIsActive[0];

          // Year
          if ((_payload40 = payload) !== null && _payload40 !== void 0 && (_payload40$filterCrit = _payload40.filterCriteria) !== null && _payload40$filterCrit !== void 0 && (_payload40$filterCrit2 = _payload40$filterCrit.yearList) !== null && _payload40$filterCrit2 !== void 0 && _payload40$filterCrit2.value) filter["colFiscalYear"] = (_payload41 = payload) === null || _payload41 === void 0 ? void 0 : (_payload41$filterCrit = _payload41.filterCriteria) === null || _payload41$filterCrit === void 0 ? void 0 : (_payload41$filterCrit2 = _payload41$filterCrit.yearList) === null || _payload41$filterCrit2 === void 0 ? void 0 : _payload41$filterCrit2.value;

          // Tag
          if (((_payload42 = payload) === null || _payload42 === void 0 ? void 0 : (_payload42$filterCrit = _payload42.filterCriteria) === null || _payload42$filterCrit === void 0 ? void 0 : (_payload42$filterCrit2 = _payload42$filterCrit.tags) === null || _payload42$filterCrit2 === void 0 ? void 0 : _payload42$filterCrit2.length) > 0) {
            colTags = "";
            (_payload43 = payload) === null || _payload43 === void 0 ? void 0 : (_payload43$filterCrit = _payload43.filterCriteria) === null || _payload43$filterCrit === void 0 ? void 0 : (_payload43$filterCrit2 = _payload43$filterCrit.tags) === null || _payload43$filterCrit2 === void 0 ? void 0 : _payload43$filterCrit2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload44 = payload) === null || _payload44 === void 0 ? true : delete _payload44.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context13.next = 13;
          return (0, _effects.call)(_services.surveyUnlockBulkApi, payload);
        case 13:
          response = _context13.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.code) === 200)) {
            _context13.next = 19;
            break;
          }
          _context13.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.UNLOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 17:
          _context13.next = 21;
          break;
        case 19:
          _context13.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNLOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context13.next = 27;
          break;
        case 23:
          _context13.prev = 23;
          _context13.t0 = _context13["catch"](0);
          _context13.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNLOCK_BULK, _context13.t0));
        case 27:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 23]]);
  })();
}

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
function surveySoftDelete(_ref14) {
  var payload = _ref14.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    var _response$data14, response;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.surveySoftDeleteApi, payload);
        case 3:
          response = _context14.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.code) === 200)) {
            _context14.next = 9;
            break;
          }
          _context14.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context14.next = 11;
          break;
        case 9:
          _context14.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context14.next = 17;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _context14.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE, _context14.t0));
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
function surveySoftDeleteBulk(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    var _payload45, _payload45$filterCrit, _payload46, _payload46$filterCrit, _payload47, _payload47$filterCrit, _payload47$filterCrit2, _payload48, _payload48$filterCrit, _payload49, _payload49$filterCrit, _payload49$filterCrit2, _payload51, _payload51$filterCrit, _payload51$filterCrit2, _payload53, _payload53$filterCrit, _payload53$filterCrit2, _payload54, _payload54$filterCrit, _payload55, _payload55$filterCrit, _payload55$filterCrit2, _payload56, _payload56$filterCrit, _payload56$filterCrit2, _payload57, _payload57$filterCrit, _payload57$filterCrit2, _payload59, _response$data15, filter, _payload50, _payload50$filterCrit, approvedAdmin, _payload52, _payload52$filterCrit, isEditedCase, _payload58, _payload58$filterCrit, _payload58$filterCrit2, colTags, response;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          filter = {}; // Search Text
          if ((_payload45 = payload) !== null && _payload45 !== void 0 && (_payload45$filterCrit = _payload45.filterCriteria) !== null && _payload45$filterCrit !== void 0 && _payload45$filterCrit.searchText) filter["searchText"] = (_payload46 = payload) === null || _payload46 === void 0 ? void 0 : (_payload46$filterCrit = _payload46.filterCriteria) === null || _payload46$filterCrit === void 0 ? void 0 : _payload46$filterCrit.searchText;

          // Owner
          if ((_payload47 = payload) !== null && _payload47 !== void 0 && (_payload47$filterCrit = _payload47.filterCriteria) !== null && _payload47$filterCrit !== void 0 && (_payload47$filterCrit2 = _payload47$filterCrit.fkUserIdList) !== null && _payload47$filterCrit2 !== void 0 && _payload47$filterCrit2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload48 = payload) === null || _payload48 === void 0 ? void 0 : (_payload48$filterCrit = _payload48.filterCriteria) === null || _payload48$filterCrit === void 0 ? void 0 : _payload48$filterCrit.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload49 = payload) === null || _payload49 === void 0 ? void 0 : (_payload49$filterCrit = _payload49.filterCriteria) === null || _payload49$filterCrit === void 0 ? void 0 : (_payload49$filterCrit2 = _payload49$filterCrit.colIsApproved) === null || _payload49$filterCrit2 === void 0 ? void 0 : _payload49$filterCrit2.length) > 0) {
            approvedAdmin = (_payload50 = payload) === null || _payload50 === void 0 ? void 0 : (_payload50$filterCrit = _payload50.filterCriteria) === null || _payload50$filterCrit === void 0 ? void 0 : _payload50$filterCrit.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload51 = payload) === null || _payload51 === void 0 ? void 0 : (_payload51$filterCrit = _payload51.filterCriteria) === null || _payload51$filterCrit === void 0 ? void 0 : (_payload51$filterCrit2 = _payload51$filterCrit.colIsEdited) === null || _payload51$filterCrit2 === void 0 ? void 0 : _payload51$filterCrit2.length) > 0) {
            isEditedCase = (_payload52 = payload) === null || _payload52 === void 0 ? void 0 : (_payload52$filterCrit = _payload52.filterCriteria) === null || _payload52$filterCrit === void 0 ? void 0 : _payload52$filterCrit.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload53 = payload) === null || _payload53 === void 0 ? void 0 : (_payload53$filterCrit = _payload53.filterCriteria) === null || _payload53$filterCrit === void 0 ? void 0 : (_payload53$filterCrit2 = _payload53$filterCrit.colIsActive) === null || _payload53$filterCrit2 === void 0 ? void 0 : _payload53$filterCrit2.length) === 1) filter["colIsActive"] = (_payload54 = payload) === null || _payload54 === void 0 ? void 0 : (_payload54$filterCrit = _payload54.filterCriteria) === null || _payload54$filterCrit === void 0 ? void 0 : _payload54$filterCrit.colIsActive[0];

          // Year
          if ((_payload55 = payload) !== null && _payload55 !== void 0 && (_payload55$filterCrit = _payload55.filterCriteria) !== null && _payload55$filterCrit !== void 0 && (_payload55$filterCrit2 = _payload55$filterCrit.yearList) !== null && _payload55$filterCrit2 !== void 0 && _payload55$filterCrit2.value) filter["colFiscalYear"] = (_payload56 = payload) === null || _payload56 === void 0 ? void 0 : (_payload56$filterCrit = _payload56.filterCriteria) === null || _payload56$filterCrit === void 0 ? void 0 : (_payload56$filterCrit2 = _payload56$filterCrit.yearList) === null || _payload56$filterCrit2 === void 0 ? void 0 : _payload56$filterCrit2.value;

          // Tag
          if (((_payload57 = payload) === null || _payload57 === void 0 ? void 0 : (_payload57$filterCrit = _payload57.filterCriteria) === null || _payload57$filterCrit === void 0 ? void 0 : (_payload57$filterCrit2 = _payload57$filterCrit.tags) === null || _payload57$filterCrit2 === void 0 ? void 0 : _payload57$filterCrit2.length) > 0) {
            colTags = "";
            (_payload58 = payload) === null || _payload58 === void 0 ? void 0 : (_payload58$filterCrit = _payload58.filterCriteria) === null || _payload58$filterCrit === void 0 ? void 0 : (_payload58$filterCrit2 = _payload58$filterCrit.tags) === null || _payload58$filterCrit2 === void 0 ? void 0 : _payload58$filterCrit2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload59 = payload) === null || _payload59 === void 0 ? true : delete _payload59.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context15.next = 13;
          return (0, _effects.call)(_services.surveySoftDeleteBulkApi, payload);
        case 13:
          response = _context15.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.code) === 200)) {
            _context15.next = 19;
            break;
          }
          _context15.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 17:
          _context15.next = 21;
          break;
        case 19:
          _context15.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context15.next = 27;
          break;
        case 23:
          _context15.prev = 23;
          _context15.t0 = _context15["catch"](0);
          _context15.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE_BULK, _context15.t0));
        case 27:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 23]]);
  })();
}

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
function surveySubmit(_ref16) {
  var payload = _ref16.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    var _response$data16, response;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.surveySubmitApi, payload);
        case 3:
          response = _context16.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.code) === 200)) {
            _context16.next = 9;
            break;
          }
          _context16.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SUBMIT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context16.next = 11;
          break;
        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SUBMIT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context16.next = 17;
          break;
        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SUBMIT, _context16.t0));
        case 17:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 13]]);
  })();
}

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
function surveySubmitBulk(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
    var _response$data17, response;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.surveySubmitBulkApi, payload);
        case 3:
          response = _context17.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.code) === 200)) {
            _context17.next = 9;
            break;
          }
          _context17.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SUBMIT_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context17.next = 11;
          break;
        case 9:
          _context17.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SUBMIT_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context17.next = 17;
          break;
        case 13:
          _context17.prev = 13;
          _context17.t0 = _context17["catch"](0);
          _context17.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SUBMIT_BULK, _context17.t0));
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 13]]);
  })();
}

/**
 * Pause
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function surveyPause(_ref18) {
  var payload = _ref18.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    var _response$data18, response;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.surveyPauseApi, payload);
        case 3:
          response = _context18.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.code) === 200)) {
            _context18.next = 9;
            break;
          }
          _context18.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.PAUSE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context18.next = 11;
          break;
        case 9:
          _context18.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PAUSE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context18.next = 17;
          break;
        case 13:
          _context18.prev = 13;
          _context18.t0 = _context18["catch"](0);
          _context18.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PAUSE, _context18.t0));
        case 17:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 13]]);
  })();
}

/**
 * Pause Bulk
 * @param payload
 * @returns api response
 * @description this function used to Pause Bulk.
 */
function surveyPauseBulk(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var _payload60, _payload60$filterCrit, _payload61, _payload61$filterCrit, _payload62, _payload62$filterCrit, _payload62$filterCrit2, _payload63, _payload63$filterCrit, _payload64, _payload64$filterCrit, _payload64$filterCrit2, _payload66, _payload66$filterCrit, _payload66$filterCrit2, _payload68, _payload68$filterCrit, _payload68$filterCrit2, _payload69, _payload69$filterCrit, _payload70, _payload70$filterCrit, _payload70$filterCrit2, _payload71, _payload71$filterCrit, _payload71$filterCrit2, _payload72, _payload72$filterCrit, _payload72$filterCrit2, _payload74, _response$data19, filter, _payload65, _payload65$filterCrit, approvedAdmin, _payload67, _payload67$filterCrit, isEditedCase, _payload73, _payload73$filterCrit, _payload73$filterCrit2, colTags, response;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          filter = {}; // Search Text
          if ((_payload60 = payload) !== null && _payload60 !== void 0 && (_payload60$filterCrit = _payload60.filterCriteria) !== null && _payload60$filterCrit !== void 0 && _payload60$filterCrit.searchText) filter["searchText"] = (_payload61 = payload) === null || _payload61 === void 0 ? void 0 : (_payload61$filterCrit = _payload61.filterCriteria) === null || _payload61$filterCrit === void 0 ? void 0 : _payload61$filterCrit.searchText;

          // Owner
          if ((_payload62 = payload) !== null && _payload62 !== void 0 && (_payload62$filterCrit = _payload62.filterCriteria) !== null && _payload62$filterCrit !== void 0 && (_payload62$filterCrit2 = _payload62$filterCrit.fkUserIdList) !== null && _payload62$filterCrit2 !== void 0 && _payload62$filterCrit2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload63 = payload) === null || _payload63 === void 0 ? void 0 : (_payload63$filterCrit = _payload63.filterCriteria) === null || _payload63$filterCrit === void 0 ? void 0 : _payload63$filterCrit.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload64 = payload) === null || _payload64 === void 0 ? void 0 : (_payload64$filterCrit = _payload64.filterCriteria) === null || _payload64$filterCrit === void 0 ? void 0 : (_payload64$filterCrit2 = _payload64$filterCrit.colIsApproved) === null || _payload64$filterCrit2 === void 0 ? void 0 : _payload64$filterCrit2.length) > 0) {
            approvedAdmin = (_payload65 = payload) === null || _payload65 === void 0 ? void 0 : (_payload65$filterCrit = _payload65.filterCriteria) === null || _payload65$filterCrit === void 0 ? void 0 : _payload65$filterCrit.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload66 = payload) === null || _payload66 === void 0 ? void 0 : (_payload66$filterCrit = _payload66.filterCriteria) === null || _payload66$filterCrit === void 0 ? void 0 : (_payload66$filterCrit2 = _payload66$filterCrit.colIsEdited) === null || _payload66$filterCrit2 === void 0 ? void 0 : _payload66$filterCrit2.length) > 0) {
            isEditedCase = (_payload67 = payload) === null || _payload67 === void 0 ? void 0 : (_payload67$filterCrit = _payload67.filterCriteria) === null || _payload67$filterCrit === void 0 ? void 0 : _payload67$filterCrit.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload68 = payload) === null || _payload68 === void 0 ? void 0 : (_payload68$filterCrit = _payload68.filterCriteria) === null || _payload68$filterCrit === void 0 ? void 0 : (_payload68$filterCrit2 = _payload68$filterCrit.colIsActive) === null || _payload68$filterCrit2 === void 0 ? void 0 : _payload68$filterCrit2.length) === 1) filter["colIsActive"] = (_payload69 = payload) === null || _payload69 === void 0 ? void 0 : (_payload69$filterCrit = _payload69.filterCriteria) === null || _payload69$filterCrit === void 0 ? void 0 : _payload69$filterCrit.colIsActive[0];

          // Year
          if ((_payload70 = payload) !== null && _payload70 !== void 0 && (_payload70$filterCrit = _payload70.filterCriteria) !== null && _payload70$filterCrit !== void 0 && (_payload70$filterCrit2 = _payload70$filterCrit.yearList) !== null && _payload70$filterCrit2 !== void 0 && _payload70$filterCrit2.value) filter["colFiscalYear"] = (_payload71 = payload) === null || _payload71 === void 0 ? void 0 : (_payload71$filterCrit = _payload71.filterCriteria) === null || _payload71$filterCrit === void 0 ? void 0 : (_payload71$filterCrit2 = _payload71$filterCrit.yearList) === null || _payload71$filterCrit2 === void 0 ? void 0 : _payload71$filterCrit2.value;

          // Tag
          if (((_payload72 = payload) === null || _payload72 === void 0 ? void 0 : (_payload72$filterCrit = _payload72.filterCriteria) === null || _payload72$filterCrit === void 0 ? void 0 : (_payload72$filterCrit2 = _payload72$filterCrit.tags) === null || _payload72$filterCrit2 === void 0 ? void 0 : _payload72$filterCrit2.length) > 0) {
            colTags = "";
            (_payload73 = payload) === null || _payload73 === void 0 ? void 0 : (_payload73$filterCrit = _payload73.filterCriteria) === null || _payload73$filterCrit === void 0 ? void 0 : (_payload73$filterCrit2 = _payload73$filterCrit.tags) === null || _payload73$filterCrit2 === void 0 ? void 0 : _payload73$filterCrit2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload74 = payload) === null || _payload74 === void 0 ? true : delete _payload74.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context19.next = 13;
          return (0, _effects.call)(_services.surveyPauseBulkApi, payload);
        case 13:
          response = _context19.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data19 = response.data) === null || _response$data19 === void 0 ? void 0 : _response$data19.code) === 200)) {
            _context19.next = 19;
            break;
          }
          _context19.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.PAUSE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 17:
          _context19.next = 21;
          break;
        case 19:
          _context19.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PAUSE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context19.next = 27;
          break;
        case 23:
          _context19.prev = 23;
          _context19.t0 = _context19["catch"](0);
          _context19.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PAUSE_BULK, _context19.t0));
        case 27:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 23]]);
  })();
}

/**
 * Resume
 * @param payload
 * @returns api response
 * @description this function used to Resume.
 */
function surveyResume(_ref20) {
  var payload = _ref20.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    var _response$data20, response;
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.surveyResumeApi, payload);
        case 3:
          response = _context20.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data20 = response.data) === null || _response$data20 === void 0 ? void 0 : _response$data20.code) === 200)) {
            _context20.next = 9;
            break;
          }
          _context20.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.RESUME, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context20.next = 11;
          break;
        case 9:
          _context20.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESUME, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context20.next = 17;
          break;
        case 13:
          _context20.prev = 13;
          _context20.t0 = _context20["catch"](0);
          _context20.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESUME, _context20.t0));
        case 17:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 13]]);
  })();
}

/**
 * Resume Bulk
 * @param payload
 * @returns api response
 * @description this function used to Resume Bulk.
 */
function surveyResumeBulk(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var _payload75, _payload75$filterCrit, _payload76, _payload76$filterCrit, _payload77, _payload77$filterCrit, _payload77$filterCrit2, _payload78, _payload78$filterCrit, _payload79, _payload79$filterCrit, _payload79$filterCrit2, _payload81, _payload81$filterCrit, _payload81$filterCrit2, _payload83, _payload83$filterCrit, _payload83$filterCrit2, _payload84, _payload84$filterCrit, _payload85, _payload85$filterCrit, _payload85$filterCrit2, _payload86, _payload86$filterCrit, _payload86$filterCrit2, _payload87, _payload87$filterCrit, _payload87$filterCrit2, _payload89, _response$data21, filter, _payload80, _payload80$filterCrit, approvedAdmin, _payload82, _payload82$filterCrit, isEditedCase, _payload88, _payload88$filterCrit, _payload88$filterCrit2, colTags, response;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          filter = {}; // Search Text
          if ((_payload75 = payload) !== null && _payload75 !== void 0 && (_payload75$filterCrit = _payload75.filterCriteria) !== null && _payload75$filterCrit !== void 0 && _payload75$filterCrit.searchText) filter["searchText"] = (_payload76 = payload) === null || _payload76 === void 0 ? void 0 : (_payload76$filterCrit = _payload76.filterCriteria) === null || _payload76$filterCrit === void 0 ? void 0 : _payload76$filterCrit.searchText;

          // Owner
          if ((_payload77 = payload) !== null && _payload77 !== void 0 && (_payload77$filterCrit = _payload77.filterCriteria) !== null && _payload77$filterCrit !== void 0 && (_payload77$filterCrit2 = _payload77$filterCrit.fkUserIdList) !== null && _payload77$filterCrit2 !== void 0 && _payload77$filterCrit2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload78 = payload) === null || _payload78 === void 0 ? void 0 : (_payload78$filterCrit = _payload78.filterCriteria) === null || _payload78$filterCrit === void 0 ? void 0 : _payload78$filterCrit.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload79 = payload) === null || _payload79 === void 0 ? void 0 : (_payload79$filterCrit = _payload79.filterCriteria) === null || _payload79$filterCrit === void 0 ? void 0 : (_payload79$filterCrit2 = _payload79$filterCrit.colIsApproved) === null || _payload79$filterCrit2 === void 0 ? void 0 : _payload79$filterCrit2.length) > 0) {
            approvedAdmin = (_payload80 = payload) === null || _payload80 === void 0 ? void 0 : (_payload80$filterCrit = _payload80.filterCriteria) === null || _payload80$filterCrit === void 0 ? void 0 : _payload80$filterCrit.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload81 = payload) === null || _payload81 === void 0 ? void 0 : (_payload81$filterCrit = _payload81.filterCriteria) === null || _payload81$filterCrit === void 0 ? void 0 : (_payload81$filterCrit2 = _payload81$filterCrit.colIsEdited) === null || _payload81$filterCrit2 === void 0 ? void 0 : _payload81$filterCrit2.length) > 0) {
            isEditedCase = (_payload82 = payload) === null || _payload82 === void 0 ? void 0 : (_payload82$filterCrit = _payload82.filterCriteria) === null || _payload82$filterCrit === void 0 ? void 0 : _payload82$filterCrit.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload83 = payload) === null || _payload83 === void 0 ? void 0 : (_payload83$filterCrit = _payload83.filterCriteria) === null || _payload83$filterCrit === void 0 ? void 0 : (_payload83$filterCrit2 = _payload83$filterCrit.colIsActive) === null || _payload83$filterCrit2 === void 0 ? void 0 : _payload83$filterCrit2.length) === 1) filter["colIsActive"] = (_payload84 = payload) === null || _payload84 === void 0 ? void 0 : (_payload84$filterCrit = _payload84.filterCriteria) === null || _payload84$filterCrit === void 0 ? void 0 : _payload84$filterCrit.colIsActive[0];

          // Year
          if ((_payload85 = payload) !== null && _payload85 !== void 0 && (_payload85$filterCrit = _payload85.filterCriteria) !== null && _payload85$filterCrit !== void 0 && (_payload85$filterCrit2 = _payload85$filterCrit.yearList) !== null && _payload85$filterCrit2 !== void 0 && _payload85$filterCrit2.value) filter["colFiscalYear"] = (_payload86 = payload) === null || _payload86 === void 0 ? void 0 : (_payload86$filterCrit = _payload86.filterCriteria) === null || _payload86$filterCrit === void 0 ? void 0 : (_payload86$filterCrit2 = _payload86$filterCrit.yearList) === null || _payload86$filterCrit2 === void 0 ? void 0 : _payload86$filterCrit2.value;

          // Tag
          if (((_payload87 = payload) === null || _payload87 === void 0 ? void 0 : (_payload87$filterCrit = _payload87.filterCriteria) === null || _payload87$filterCrit === void 0 ? void 0 : (_payload87$filterCrit2 = _payload87$filterCrit.tags) === null || _payload87$filterCrit2 === void 0 ? void 0 : _payload87$filterCrit2.length) > 0) {
            colTags = "";
            (_payload88 = payload) === null || _payload88 === void 0 ? void 0 : (_payload88$filterCrit = _payload88.filterCriteria) === null || _payload88$filterCrit === void 0 ? void 0 : (_payload88$filterCrit2 = _payload88$filterCrit.tags) === null || _payload88$filterCrit2 === void 0 ? void 0 : _payload88$filterCrit2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload89 = payload) === null || _payload89 === void 0 ? true : delete _payload89.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context21.next = 13;
          return (0, _effects.call)(_services.surveyResumeBulkApi, payload);
        case 13:
          response = _context21.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data21 = response.data) === null || _response$data21 === void 0 ? void 0 : _response$data21.code) === 200)) {
            _context21.next = 19;
            break;
          }
          _context21.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.RESUME_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 17:
          _context21.next = 21;
          break;
        case 19:
          _context21.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESUME_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context21.next = 27;
          break;
        case 23:
          _context21.prev = 23;
          _context21.t0 = _context21["catch"](0);
          _context21.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESUME_BULK, _context21.t0));
        case 27:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 23]]);
  })();
}

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function surveyCopyUrl(_ref22) {
  var payload = _ref22.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var _response$data22, response, _response$data23;
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return (0, _effects.call)(_services.surveyCopyUrlApi, payload);
        case 3:
          response = _context22.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data22 = response.data) === null || _response$data22 === void 0 ? void 0 : _response$data22.code) === 200)) {
            _context22.next = 9;
            break;
          }
          _context22.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.COPY_URL, response === null || response === void 0 ? void 0 : (_response$data23 = response.data) === null || _response$data23 === void 0 ? void 0 : _response$data23.data));
        case 7:
          _context22.next = 11;
          break;
        case 9:
          _context22.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.COPY_URL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context22.next = 17;
          break;
        case 13:
          _context22.prev = 13;
          _context22.t0 = _context22["catch"](0);
          _context22.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.COPY_URL, _context22.t0));
        case 17:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 13]]);
  })();
}

/**
 * Magic Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function surveyMagicUrl(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var _response$data24, response, _response$data25;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return (0, _effects.call)(_services.surveyMagicUrlApi, payload);
        case 3:
          response = _context23.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data24 = response.data) === null || _response$data24 === void 0 ? void 0 : _response$data24.code) === 200)) {
            _context23.next = 9;
            break;
          }
          _context23.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.MAGIC_URL, response === null || response === void 0 ? void 0 : (_response$data25 = response.data) === null || _response$data25 === void 0 ? void 0 : _response$data25.data));
        case 7:
          _context23.next = 11;
          break;
        case 9:
          _context23.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.MAGIC_URL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context23.next = 17;
          break;
        case 13:
          _context23.prev = 13;
          _context23.t0 = _context23["catch"](0);
          _context23.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.MAGIC_URL, _context23.t0));
        case 17:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 13]]);
  })();
}

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
function surveyDownloadAll(_ref24) {
  var payload = _ref24.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var _response$data26, response;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return (0, _effects.call)(_services.surveyDownloadAllApi, payload);
        case 3:
          response = _context24.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data26 = response.data) === null || _response$data26 === void 0 ? void 0 : _response$data26.code) === 200)) {
            _context24.next = 9;
            break;
          }
          _context24.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.DOWNLOAD_ALL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context24.next = 11;
          break;
        case 9:
          _context24.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DOWNLOAD_ALL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context24.next = 17;
          break;
        case 13:
          _context24.prev = 13;
          _context24.t0 = _context24["catch"](0);
          _context24.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DOWNLOAD_ALL, _context24.t0));
        case 17:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 13]]);
  })();
}

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
function surveyDownloadSurveyResponse(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var _response$data27, response;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _effects.call)(_services.surveyDownloadSurveyResponseApi, payload);
        case 3:
          response = _context25.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data27 = response.data) === null || _response$data27 === void 0 ? void 0 : _response$data27.code) === 200)) {
            _context25.next = 9;
            break;
          }
          _context25.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context25.next = 11;
          break;
        case 9:
          _context25.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context25.next = 17;
          break;
        case 13:
          _context25.prev = 13;
          _context25.t0 = _context25["catch"](0);
          _context25.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, _context25.t0));
        case 17:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[0, 13]]);
  })();
}

// unique url extension

/**
 * survey unique url extension
 * @param payload
 * @returns api response
 * @description this function used to get unique url extension of survey.
 */
function surveyUniqueUrlExtensionSg(_ref26) {
  var payload = _ref26.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
    var _response$data28, response, _response$data29;
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return (0, _effects.call)(_services.surveyUniqueUrlExtensionApi, payload);
        case 3:
          response = _context26.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data28 = response.data) === null || _response$data28 === void 0 ? void 0 : _response$data28.code) === 202)) {
            _context26.next = 9;
            break;
          }
          _context26.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.UNIQUE_URL_EXTENSION, response === null || response === void 0 ? void 0 : (_response$data29 = response.data) === null || _response$data29 === void 0 ? void 0 : _response$data29.data));
        case 7:
          _context26.next = 11;
          break;
        case 9:
          _context26.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNIQUE_URL_EXTENSION, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context26.next = 17;
          break;
        case 13:
          _context26.prev = 13;
          _context26.t0 = _context26["catch"](0);
          _context26.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.UNIQUE_URL_EXTENSION, _context26.t0));
        case 17:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 13]]);
  })();
}

// deleted data

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
function surveySoftDeleteList(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    var _payload90, _payload90$fkUserIdLi, _payload91, _payload91$fkUserIdLi, _payload92, _payload93, _payload94, _payload94$fkDeletedB, _payload95, _payload95$fkDeletedB, _payload96, _payload97, _payload98, _payload99, _payload100, _payload101, _payload101$yearList, _payload102, _payload102$yearList, _payload103, _payload103$tags, _response$data30, filter, _payload104, _payload104$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.prev = 0;
          filter = {}; // Owner
          if ((_payload90 = payload) !== null && _payload90 !== void 0 && (_payload90$fkUserIdLi = _payload90.fkUserIdList) !== null && _payload90$fkUserIdLi !== void 0 && _payload90$fkUserIdLi.value) filter["fkUserIdList"] = (_payload91 = payload) === null || _payload91 === void 0 ? void 0 : (_payload91$fkUserIdLi = _payload91.fkUserIdList) === null || _payload91$fkUserIdLi === void 0 ? void 0 : _payload91$fkUserIdLi.value;else if (Array.isArray((_payload92 = payload) === null || _payload92 === void 0 ? void 0 : _payload92.fkUserIdList)) filter["fkUserIdList"] = (_payload93 = payload) === null || _payload93 === void 0 ? void 0 : _payload93.fkUserIdList;
          if ((_payload94 = payload) !== null && _payload94 !== void 0 && (_payload94$fkDeletedB = _payload94.fkDeletedByList) !== null && _payload94$fkDeletedB !== void 0 && _payload94$fkDeletedB.value) filter["fkDeletedByList"] = (_payload95 = payload) === null || _payload95 === void 0 ? void 0 : (_payload95$fkDeletedB = _payload95.fkDeletedByList) === null || _payload95$fkDeletedB === void 0 ? void 0 : _payload95$fkDeletedB.value;else if (Array.isArray((_payload96 = payload) === null || _payload96 === void 0 ? void 0 : _payload96.fkDeletedByList)) filter["fkDeletedByList"] = (_payload97 = payload) === null || _payload97 === void 0 ? void 0 : _payload97.fkDeletedByList;
          if (((_payload98 = payload) === null || _payload98 === void 0 ? void 0 : _payload98.dateRange) === "date" && (_payload99 = payload) !== null && _payload99 !== void 0 && _payload99.from && (_payload100 = payload) !== null && _payload100 !== void 0 && _payload100.to) {
            filter["startDate"] = payload.from;
            filter["endDate"] = payload.to;
          }

          // Year
          if ((_payload101 = payload) !== null && _payload101 !== void 0 && (_payload101$yearList = _payload101.yearList) !== null && _payload101$yearList !== void 0 && _payload101$yearList.value) filter["colFiscalYear"] = (_payload102 = payload) === null || _payload102 === void 0 ? void 0 : (_payload102$yearList = _payload102.yearList) === null || _payload102$yearList === void 0 ? void 0 : _payload102$yearList.value;
          if (((_payload103 = payload) === null || _payload103 === void 0 ? void 0 : (_payload103$tags = _payload103.tags) === null || _payload103$tags === void 0 ? void 0 : _payload103$tags.length) > 0) {
            colTags = "";
            (_payload104 = payload) === null || _payload104 === void 0 ? void 0 : (_payload104$tags = _payload104.tags) === null || _payload104$tags === void 0 ? void 0 : _payload104$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.yearList;
          delete payload.fkDeletedByList;
          delete payload.colTags;
          delete payload.from;
          delete payload.to;
          delete payload.tags;
          delete payload.dateRange;
          delete payload.startDate;
          delete payload.endDate;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context27.next = 20;
          return (0, _effects.call)(_services.surveySoftDeleteListApi, payload);
        case 20:
          response = _context27.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data30 = response.data) === null || _response$data30 === void 0 ? void 0 : _response$data30.code) === 200)) {
            _context27.next = 26;
            break;
          }
          _context27.next = 24;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 24:
          _context27.next = 28;
          break;
        case 26:
          _context27.next = 28;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 28:
          _context27.next = 34;
          break;
        case 30:
          _context27.prev = 30;
          _context27.t0 = _context27["catch"](0);
          _context27.next = 34;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.SOFT_DELETE_LIST, _context27.t0));
        case 34:
        case "end":
          return _context27.stop();
      }
    }, _callee27, null, [[0, 30]]);
  })();
}

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
function surveyRestore(_ref28) {
  var payload = _ref28.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
    var _response$data31, response;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          _context28.next = 3;
          return (0, _effects.call)(_services.surveyRestoreApi, payload);
        case 3:
          response = _context28.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data31 = response.data) === null || _response$data31 === void 0 ? void 0 : _response$data31.code) === 200)) {
            _context28.next = 9;
            break;
          }
          _context28.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context28.next = 11;
          break;
        case 9:
          _context28.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context28.next = 17;
          break;
        case 13:
          _context28.prev = 13;
          _context28.t0 = _context28["catch"](0);
          _context28.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESTORE, _context28.t0));
        case 17:
        case "end":
          return _context28.stop();
      }
    }, _callee28, null, [[0, 13]]);
  })();
}

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
function surveyRestoreBulk(_ref29) {
  var payload = _ref29.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
    var _payload105, _payload105$filterCri, _payload106, _payload106$filterCri, _payload107, _payload107$filterCri, _payload107$filterCri2, _payload108, _payload108$filterCri, _payload109, _payload109$filterCri, _payload109$filterCri2, _payload111, _payload111$filterCri, _payload111$filterCri2, _payload113, _payload113$filterCri, _payload113$filterCri2, _payload114, _payload114$filterCri, _payload115, _payload115$filterCri, _payload115$filterCri2, _payload116, _payload116$filterCri, _payload116$filterCri2, _payload117, _payload117$filterCri, _payload117$filterCri2, _payload119, _response$data32, filter, _payload110, _payload110$filterCri, approvedAdmin, _payload112, _payload112$filterCri, isEditedCase, _payload118, _payload118$filterCri, _payload118$filterCri2, colTags, response, _response$data33;
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          filter = {}; // Search Text
          if ((_payload105 = payload) !== null && _payload105 !== void 0 && (_payload105$filterCri = _payload105.filterCriteria) !== null && _payload105$filterCri !== void 0 && _payload105$filterCri.searchText) filter["searchText"] = (_payload106 = payload) === null || _payload106 === void 0 ? void 0 : (_payload106$filterCri = _payload106.filterCriteria) === null || _payload106$filterCri === void 0 ? void 0 : _payload106$filterCri.searchText;

          // Owner
          if ((_payload107 = payload) !== null && _payload107 !== void 0 && (_payload107$filterCri = _payload107.filterCriteria) !== null && _payload107$filterCri !== void 0 && (_payload107$filterCri2 = _payload107$filterCri.fkUserIdList) !== null && _payload107$filterCri2 !== void 0 && _payload107$filterCri2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload108 = payload) === null || _payload108 === void 0 ? void 0 : (_payload108$filterCri = _payload108.filterCriteria) === null || _payload108$filterCri === void 0 ? void 0 : _payload108$filterCri.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload109 = payload) === null || _payload109 === void 0 ? void 0 : (_payload109$filterCri = _payload109.filterCriteria) === null || _payload109$filterCri === void 0 ? void 0 : (_payload109$filterCri2 = _payload109$filterCri.colIsApproved) === null || _payload109$filterCri2 === void 0 ? void 0 : _payload109$filterCri2.length) > 0) {
            approvedAdmin = (_payload110 = payload) === null || _payload110 === void 0 ? void 0 : (_payload110$filterCri = _payload110.filterCriteria) === null || _payload110$filterCri === void 0 ? void 0 : _payload110$filterCri.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload111 = payload) === null || _payload111 === void 0 ? void 0 : (_payload111$filterCri = _payload111.filterCriteria) === null || _payload111$filterCri === void 0 ? void 0 : (_payload111$filterCri2 = _payload111$filterCri.colIsEdited) === null || _payload111$filterCri2 === void 0 ? void 0 : _payload111$filterCri2.length) > 0) {
            isEditedCase = (_payload112 = payload) === null || _payload112 === void 0 ? void 0 : (_payload112$filterCri = _payload112.filterCriteria) === null || _payload112$filterCri === void 0 ? void 0 : _payload112$filterCri.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload113 = payload) === null || _payload113 === void 0 ? void 0 : (_payload113$filterCri = _payload113.filterCriteria) === null || _payload113$filterCri === void 0 ? void 0 : (_payload113$filterCri2 = _payload113$filterCri.colIsActive) === null || _payload113$filterCri2 === void 0 ? void 0 : _payload113$filterCri2.length) === 1) filter["colIsActive"] = (_payload114 = payload) === null || _payload114 === void 0 ? void 0 : (_payload114$filterCri = _payload114.filterCriteria) === null || _payload114$filterCri === void 0 ? void 0 : _payload114$filterCri.colIsActive[0];

          // Year
          if ((_payload115 = payload) !== null && _payload115 !== void 0 && (_payload115$filterCri = _payload115.filterCriteria) !== null && _payload115$filterCri !== void 0 && (_payload115$filterCri2 = _payload115$filterCri.yearList) !== null && _payload115$filterCri2 !== void 0 && _payload115$filterCri2.value) filter["colFiscalYear"] = (_payload116 = payload) === null || _payload116 === void 0 ? void 0 : (_payload116$filterCri = _payload116.filterCriteria) === null || _payload116$filterCri === void 0 ? void 0 : (_payload116$filterCri2 = _payload116$filterCri.yearList) === null || _payload116$filterCri2 === void 0 ? void 0 : _payload116$filterCri2.value;

          // Tag
          if (((_payload117 = payload) === null || _payload117 === void 0 ? void 0 : (_payload117$filterCri = _payload117.filterCriteria) === null || _payload117$filterCri === void 0 ? void 0 : (_payload117$filterCri2 = _payload117$filterCri.tags) === null || _payload117$filterCri2 === void 0 ? void 0 : _payload117$filterCri2.length) > 0) {
            colTags = "";
            (_payload118 = payload) === null || _payload118 === void 0 ? void 0 : (_payload118$filterCri = _payload118.filterCriteria) === null || _payload118$filterCri === void 0 ? void 0 : (_payload118$filterCri2 = _payload118$filterCri.tags) === null || _payload118$filterCri2 === void 0 ? void 0 : _payload118$filterCri2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload119 = payload) === null || _payload119 === void 0 ? true : delete _payload119.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context29.next = 13;
          return (0, _effects.call)(_services.surveyRestoreBulkApi, payload);
        case 13:
          response = _context29.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data32 = response.data) === null || _response$data32 === void 0 ? void 0 : _response$data32.code) === 207)) {
            _context29.next = 19;
            break;
          }
          _context29.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.RESTORE_BULK, response === null || response === void 0 ? void 0 : (_response$data33 = response.data) === null || _response$data33 === void 0 ? void 0 : _response$data33.data));
        case 17:
          _context29.next = 21;
          break;
        case 19:
          _context29.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESTORE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context29.next = 27;
          break;
        case 23:
          _context29.prev = 23;
          _context29.t0 = _context29["catch"](0);
          _context29.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.RESTORE_BULK, _context29.t0));
        case 27:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 23]]);
  })();
}

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
function surveyDelete(_ref30) {
  var payload = _ref30.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
    var _response$data34, response;
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.prev = 0;
          _context30.next = 3;
          return (0, _effects.call)(_services.surveyDeleteApi, payload);
        case 3:
          response = _context30.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data34 = response.data) === null || _response$data34 === void 0 ? void 0 : _response$data34.code) === 200)) {
            _context30.next = 9;
            break;
          }
          _context30.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context30.next = 11;
          break;
        case 9:
          _context30.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context30.next = 17;
          break;
        case 13:
          _context30.prev = 13;
          _context30.t0 = _context30["catch"](0);
          _context30.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DELETE, _context30.t0));
        case 17:
        case "end":
          return _context30.stop();
      }
    }, _callee30, null, [[0, 13]]);
  })();
}

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
function surveyDeleteBulk(_ref31) {
  var payload = _ref31.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
    var _payload120, _payload120$filterCri, _payload121, _payload121$filterCri, _payload122, _payload122$filterCri, _payload122$filterCri2, _payload123, _payload123$filterCri, _payload124, _payload124$filterCri, _payload124$filterCri2, _payload126, _payload126$filterCri, _payload126$filterCri2, _payload128, _payload128$filterCri, _payload128$filterCri2, _payload129, _payload129$filterCri, _payload130, _payload130$filterCri, _payload130$filterCri2, _payload131, _payload131$filterCri, _payload131$filterCri2, _payload132, _payload132$filterCri, _payload132$filterCri2, _payload134, _response$data35, filter, _payload125, _payload125$filterCri, approvedAdmin, _payload127, _payload127$filterCri, isEditedCase, _payload133, _payload133$filterCri, _payload133$filterCri2, colTags, response, _response$data36;
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.prev = 0;
          filter = {}; // Search Text
          if ((_payload120 = payload) !== null && _payload120 !== void 0 && (_payload120$filterCri = _payload120.filterCriteria) !== null && _payload120$filterCri !== void 0 && _payload120$filterCri.searchText) filter["searchText"] = (_payload121 = payload) === null || _payload121 === void 0 ? void 0 : (_payload121$filterCri = _payload121.filterCriteria) === null || _payload121$filterCri === void 0 ? void 0 : _payload121$filterCri.searchText;

          // Owner
          if ((_payload122 = payload) !== null && _payload122 !== void 0 && (_payload122$filterCri = _payload122.filterCriteria) !== null && _payload122$filterCri !== void 0 && (_payload122$filterCri2 = _payload122$filterCri.fkUserIdList) !== null && _payload122$filterCri2 !== void 0 && _payload122$filterCri2.value) filter["fkUserIdList"] = [payload.filterCriteria.fkUserIdList.value];else if (Array.isArray((_payload123 = payload) === null || _payload123 === void 0 ? void 0 : (_payload123$filterCri = _payload123.filterCriteria) === null || _payload123$filterCri === void 0 ? void 0 : _payload123$filterCri.fkUserIdList)) filter["fkUserIdList"] = payload.filterCriteria.fkUserIdList;

          // Approved
          if (((_payload124 = payload) === null || _payload124 === void 0 ? void 0 : (_payload124$filterCri = _payload124.filterCriteria) === null || _payload124$filterCri === void 0 ? void 0 : (_payload124$filterCri2 = _payload124$filterCri.colIsApproved) === null || _payload124$filterCri2 === void 0 ? void 0 : _payload124$filterCri2.length) > 0) {
            approvedAdmin = (_payload125 = payload) === null || _payload125 === void 0 ? void 0 : (_payload125$filterCri = _payload125.filterCriteria) === null || _payload125$filterCri === void 0 ? void 0 : _payload125$filterCri.colIsApproved;
            approvedAdmin.map(function (item) {
              if (item === "isSubmited") filter["submit"] = true;else if (item === true) filter["approved"] = true;else filter["pending"] = true;
            });
          }

          // Edit
          if (((_payload126 = payload) === null || _payload126 === void 0 ? void 0 : (_payload126$filterCri = _payload126.filterCriteria) === null || _payload126$filterCri === void 0 ? void 0 : (_payload126$filterCri2 = _payload126$filterCri.colIsEdited) === null || _payload126$filterCri2 === void 0 ? void 0 : _payload126$filterCri2.length) > 0) {
            isEditedCase = (_payload127 = payload) === null || _payload127 === void 0 ? void 0 : (_payload127$filterCri = _payload127.filterCriteria) === null || _payload127$filterCri === void 0 ? void 0 : _payload127$filterCri.colIsEdited;
            isEditedCase.map(function (item) {
              if (item === "colIsRestricted") filter["restricted"] = true;else if (item === "colIsLocked") filter["locked"] = true;else if (item === true) filter["edited"] = true;else filter["unedited"] = true;
            });
          }

          // Status
          if (((_payload128 = payload) === null || _payload128 === void 0 ? void 0 : (_payload128$filterCri = _payload128.filterCriteria) === null || _payload128$filterCri === void 0 ? void 0 : (_payload128$filterCri2 = _payload128$filterCri.colIsActive) === null || _payload128$filterCri2 === void 0 ? void 0 : _payload128$filterCri2.length) === 1) filter["colIsActive"] = (_payload129 = payload) === null || _payload129 === void 0 ? void 0 : (_payload129$filterCri = _payload129.filterCriteria) === null || _payload129$filterCri === void 0 ? void 0 : _payload129$filterCri.colIsActive[0];

          // Year
          if ((_payload130 = payload) !== null && _payload130 !== void 0 && (_payload130$filterCri = _payload130.filterCriteria) !== null && _payload130$filterCri !== void 0 && (_payload130$filterCri2 = _payload130$filterCri.yearList) !== null && _payload130$filterCri2 !== void 0 && _payload130$filterCri2.value) filter["colFiscalYear"] = (_payload131 = payload) === null || _payload131 === void 0 ? void 0 : (_payload131$filterCri = _payload131.filterCriteria) === null || _payload131$filterCri === void 0 ? void 0 : (_payload131$filterCri2 = _payload131$filterCri.yearList) === null || _payload131$filterCri2 === void 0 ? void 0 : _payload131$filterCri2.value;

          // Tag
          if (((_payload132 = payload) === null || _payload132 === void 0 ? void 0 : (_payload132$filterCri = _payload132.filterCriteria) === null || _payload132$filterCri === void 0 ? void 0 : (_payload132$filterCri2 = _payload132$filterCri.tags) === null || _payload132$filterCri2 === void 0 ? void 0 : _payload132$filterCri2.length) > 0) {
            colTags = "";
            (_payload133 = payload) === null || _payload133 === void 0 ? void 0 : (_payload133$filterCri = _payload133.filterCriteria) === null || _payload133$filterCri === void 0 ? void 0 : (_payload133$filterCri2 = _payload133$filterCri.tags) === null || _payload133$filterCri2 === void 0 ? void 0 : _payload133$filterCri2.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload134 = payload) === null || _payload134 === void 0 ? true : delete _payload134.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context31.next = 13;
          return (0, _effects.call)(_services.surveyDeleteBulkApi, payload);
        case 13:
          response = _context31.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data35 = response.data) === null || _response$data35 === void 0 ? void 0 : _response$data35.code) === 207)) {
            _context31.next = 19;
            break;
          }
          _context31.next = 17;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.DELETE_BULK, response === null || response === void 0 ? void 0 : (_response$data36 = response.data) === null || _response$data36 === void 0 ? void 0 : _response$data36.data));
        case 17:
          _context31.next = 21;
          break;
        case 19:
          _context31.next = 21;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 21:
          _context31.next = 27;
          break;
        case 23:
          _context31.prev = 23;
          _context31.t0 = _context31["catch"](0);
          _context31.next = 27;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.DELETE_BULK, _context31.t0));
        case 27:
        case "end":
          return _context31.stop();
      }
    }, _callee31, null, [[0, 23]]);
  })();
}

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
function surveyPrefight(_ref32) {
  var payload = _ref32.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
    var _response$data37, response;
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.prev = 0;
          _context32.next = 3;
          return (0, _effects.call)(_services.surveyPrefightApi, payload);
        case 3:
          response = _context32.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data37 = response.data) === null || _response$data37 === void 0 ? void 0 : _response$data37.code) === 200)) {
            _context32.next = 9;
            break;
          }
          _context32.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.PREFIGHT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context32.next = 11;
          break;
        case 9:
          _context32.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PREFIGHT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context32.next = 17;
          break;
        case 13:
          _context32.prev = 13;
          _context32.t0 = _context32["catch"](0);
          _context32.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.PREFIGHT, _context32.t0));
        case 17:
        case "end":
          return _context32.stop();
      }
    }, _callee32, null, [[0, 13]]);
  })();
}

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
function surveyImport(_ref33) {
  var payload = _ref33.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
    var _response$data38, response;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.prev = 0;
          _context33.next = 3;
          return (0, _effects.call)(_services.surveyImportApi, payload);
        case 3:
          response = _context33.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data38 = response.data) === null || _response$data38 === void 0 ? void 0 : _response$data38.code) === 201)) {
            _context33.next = 9;
            break;
          }
          _context33.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.IMPORT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context33.next = 11;
          break;
        case 9:
          _context33.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.IMPORT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context33.next = 17;
          break;
        case 13:
          _context33.prev = 13;
          _context33.t0 = _context33["catch"](0);
          _context33.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.IMPORT, _context33.t0));
        case 17:
        case "end":
          return _context33.stop();
      }
    }, _callee33, null, [[0, 13]]);
  })();
}

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
function surveyErrorSheetDownload(_ref34) {
  var payload = _ref34.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
    var _response$data39, response;
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.prev = 0;
          _context34.next = 3;
          return (0, _effects.call)(_services.surveyErrorSheetDownloadApi, payload);
        case 3:
          response = _context34.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data39 = response.data) === null || _response$data39 === void 0 ? void 0 : _response$data39.code) === 200)) {
            _context34.next = 9;
            break;
          }
          _context34.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.ERROR_SHEET_DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context34.next = 11;
          break;
        case 9:
          _context34.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ERROR_SHEET_DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context34.next = 17;
          break;
        case 13:
          _context34.prev = 13;
          _context34.t0 = _context34["catch"](0);
          _context34.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ERROR_SHEET_DOWNLOAD, _context34.t0));
        case 17:
        case "end":
          return _context34.stop();
      }
    }, _callee34, null, [[0, 13]]);
  })();
}

// analytics

/**
 * Analytics Save
 * @param payload
 * @returns api response
 * @description this function used to Analytics Save.
 */
function surveyAnalyticsSave(_ref35) {
  var payload = _ref35.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
    var _response$data40, response;
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.prev = 0;
          _context35.next = 3;
          return (0, _effects.call)(_services.surveyAnalyticsSaveApi, payload);
        case 3:
          response = _context35.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data40 = response.data) === null || _response$data40 === void 0 ? void 0 : _response$data40.code) === 201)) {
            _context35.next = 9;
            break;
          }
          _context35.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.ANALYTICS_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context35.next = 11;
          break;
        case 9:
          _context35.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context35.next = 17;
          break;
        case 13:
          _context35.prev = 13;
          _context35.t0 = _context35["catch"](0);
          _context35.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_SAVE, _context35.t0));
        case 17:
        case "end":
          return _context35.stop();
      }
    }, _callee35, null, [[0, 13]]);
  })();
}

/**
 * Analytics Get
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get.
 */
function surveyAnalyticsGet(_ref36) {
  var payload = _ref36.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
    var _response$data41, response;
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          _context36.prev = 0;
          _context36.next = 3;
          return (0, _effects.call)(_services.surveyAnalyticsGetApi, payload);
        case 3:
          response = _context36.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data41 = response.data) === null || _response$data41 === void 0 ? void 0 : _response$data41.code) === 200)) {
            _context36.next = 9;
            break;
          }
          _context36.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.ANALYTICS_GET, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context36.next = 11;
          break;
        case 9:
          _context36.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_GET, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context36.next = 17;
          break;
        case 13:
          _context36.prev = 13;
          _context36.t0 = _context36["catch"](0);
          _context36.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_GET, _context36.t0));
        case 17:
        case "end":
          return _context36.stop();
      }
    }, _callee36, null, [[0, 13]]);
  })();
}

/**
 * Analytics Update
 * @param payload
 * @returns api response
 * @description this function used to Analytics Update.
 */
function surveyAnalyticsUpdate(_ref37) {
  var payload = _ref37.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
    var _response$data42, response;
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          _context37.prev = 0;
          _context37.next = 3;
          return (0, _effects.call)(_services.surveyAnalyticsUpdateApi, payload);
        case 3:
          response = _context37.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data42 = response.data) === null || _response$data42 === void 0 ? void 0 : _response$data42.code) === 202)) {
            _context37.next = 9;
            break;
          }
          _context37.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.ANALYTICS_UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context37.next = 11;
          break;
        case 9:
          _context37.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context37.next = 17;
          break;
        case 13:
          _context37.prev = 13;
          _context37.t0 = _context37["catch"](0);
          _context37.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.ANALYTICS_UPDATE, _context37.t0));
        case 17:
        case "end":
          return _context37.stop();
      }
    }, _callee37, null, [[0, 13]]);
  })();
}

// configuration

/**
 * List Configuration
 * @param payload
 * @returns api response
 * @description this function used to List Configuration.
 */
function surveyListConfiguration(_ref38) {
  var payload = _ref38.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
    var _response$data43, response;
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.prev = 0;
          _context38.next = 3;
          return (0, _effects.call)(_services.surveyListConfigurationApi, payload);
        case 3:
          response = _context38.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data43 = response.data) === null || _response$data43 === void 0 ? void 0 : _response$data43.code) === 200)) {
            _context38.next = 9;
            break;
          }
          _context38.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LIST_CONFIGURATION, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context38.next = 11;
          break;
        case 9:
          _context38.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LIST_CONFIGURATION, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context38.next = 17;
          break;
        case 13:
          _context38.prev = 13;
          _context38.t0 = _context38["catch"](0);
          _context38.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LIST_CONFIGURATION, _context38.t0));
        case 17:
        case "end":
          return _context38.stop();
      }
    }, _callee38, null, [[0, 13]]);
  })();
}

/**
 * Fetch Configuration
 * @param payload
 * @returns api response
 * @description this function used to Fetch Configuration.
 */
function surveyFetchConfiguration(_ref39) {
  var payload = _ref39.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
    var _response$data44, response;
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.prev = 0;
          _context39.next = 3;
          return (0, _effects.call)(_services.surveyFetchConfigurationApi, payload);
        case 3:
          response = _context39.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data44 = response.data) === null || _response$data44 === void 0 ? void 0 : _response$data44.code) === 200)) {
            _context39.next = 9;
            break;
          }
          _context39.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.FETCH_CONFIGURATION, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context39.next = 11;
          break;
        case 9:
          _context39.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH_CONFIGURATION, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context39.next = 17;
          break;
        case 13:
          _context39.prev = 13;
          _context39.t0 = _context39["catch"](0);
          _context39.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.FETCH_CONFIGURATION, _context39.t0));
        case 17:
        case "end":
          return _context39.stop();
      }
    }, _callee39, null, [[0, 13]]);
  })();
}

// review and approve

/**
 * List Review And Approve
 * @param payload
 * @returns api response
 * @description this function used to List Review And Approve.
 */
function surveyListReviewAndApprove(_ref40) {
  var payload = _ref40.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
    var _response$data45, response;
    return _regeneratorRuntime().wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          _context40.prev = 0;
          _context40.next = 3;
          return (0, _effects.call)(_services.surveyListReviewAndApproveApi, payload);
        case 3:
          response = _context40.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data45 = response.data) === null || _response$data45 === void 0 ? void 0 : _response$data45.code) === 200)) {
            _context40.next = 7;
            break;
          }
          _context40.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.LIST_REVIEW_APPROVAL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context40.next = 13;
          break;
        case 9:
          _context40.prev = 9;
          _context40.t0 = _context40["catch"](0);
          _context40.next = 13;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.LIST_REVIEW_APPROVAL, _context40.t0));
        case 13:
        case "end":
          return _context40.stop();
      }
    }, _callee40, null, [[0, 9]]);
  })();
}

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 * @description this function used to Approve.
 */
function surveyApprove(_ref41) {
  var payload = _ref41.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
    var _response$data46, response;
    return _regeneratorRuntime().wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          _context41.prev = 0;
          _context41.next = 3;
          return (0, _effects.call)(_services.surveyApproveApi, payload);
        case 3:
          response = _context41.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data46 = response.data) === null || _response$data46 === void 0 ? void 0 : _response$data46.code) === 200)) {
            _context41.next = 9;
            break;
          }
          _context41.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.APPROVE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context41.next = 11;
          break;
        case 9:
          _context41.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.APPROVE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context41.next = 17;
          break;
        case 13:
          _context41.prev = 13;
          _context41.t0 = _context41["catch"](0);
          _context41.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.APPROVE, _context41.t0));
        case 17:
        case "end":
          return _context41.stop();
      }
    }, _callee41, null, [[0, 13]]);
  })();
}

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 * @description this function used to Approve Bulk.
 */
function surveyApproveBulk(_ref42) {
  var payload = _ref42.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
    var _response$data47, response;
    return _regeneratorRuntime().wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          _context42.prev = 0;
          _context42.next = 3;
          return (0, _effects.call)(_services.surveyApproveBulkApi, payload);
        case 3:
          response = _context42.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data47 = response.data) === null || _response$data47 === void 0 ? void 0 : _response$data47.code) === 200)) {
            _context42.next = 9;
            break;
          }
          _context42.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.APPROVE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context42.next = 11;
          break;
        case 9:
          _context42.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.APPROVE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context42.next = 17;
          break;
        case 13:
          _context42.prev = 13;
          _context42.t0 = _context42["catch"](0);
          _context42.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.APPROVE_BULK, _context42.t0));
        case 17:
        case "end":
          return _context42.stop();
      }
    }, _callee42, null, [[0, 13]]);
  })();
}

// editor

/**
 * Editor Fetch
 * @param payload
 * @returns api response
 * @description this function used to Editor Fetch.
 * @description this function used to Editor Fetch.
 */
function surveyEditorFetch(_ref43) {
  var payload = _ref43.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
    var _response$data48, response;
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          _context43.prev = 0;
          _context43.next = 3;
          return (0, _effects.call)(_services.surveyEditorFetchApi, payload);
        case 3:
          response = _context43.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data48 = response.data) === null || _response$data48 === void 0 ? void 0 : _response$data48.code) === 200)) {
            _context43.next = 9;
            break;
          }
          _context43.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_FETCH, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context43.next = 11;
          break;
        case 9:
          _context43.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_FETCH, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context43.next = 17;
          break;
        case 13:
          _context43.prev = 13;
          _context43.t0 = _context43["catch"](0);
          _context43.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_FETCH, _context43.t0));
        case 17:
        case "end":
          return _context43.stop();
      }
    }, _callee43, null, [[0, 13]]);
  })();
}

/**
 * Editor Save
 * @param payload
 * @returns api response
 * @description this function used to Editor Save.
 * @description this function used to Editor Save.
 */
function surveyEditorSave(_ref44) {
  var payload = _ref44.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
    var _response$data49, response;
    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          _context44.prev = 0;
          _context44.next = 3;
          return (0, _effects.call)(_services.surveyEditorSaveApi, payload);
        case 3:
          response = _context44.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data49 = response.data) === null || _response$data49 === void 0 ? void 0 : _response$data49.code) === 202)) {
            _context44.next = 9;
            break;
          }
          _context44.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context44.next = 11;
          break;
        case 9:
          _context44.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_SAVE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context44.next = 17;
          break;
        case 13:
          _context44.prev = 13;
          _context44.t0 = _context44["catch"](0);
          _context44.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_SAVE, _context44.t0));
        case 17:
        case "end":
          return _context44.stop();
      }
    }, _callee44, null, [[0, 13]]);
  })();
}

/**
 * Editor Change Brand
 * @param payload
 * @returns api response
 * @description this function used to Editor Change Brand.
 * @description this function used to Editor Change Brand.
 */
function surveyEditorChangeBrand(_ref45) {
  var payload = _ref45.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
    var _response$data50, response;
    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          _context45.prev = 0;
          _context45.next = 3;
          return (0, _effects.call)(_services.surveyEditorChangeBrandApi, payload);
        case 3:
          response = _context45.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data50 = response.data) === null || _response$data50 === void 0 ? void 0 : _response$data50.code) === 202)) {
            _context45.next = 9;
            break;
          }
          _context45.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_CHANGE_BRAND, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context45.next = 11;
          break;
        case 9:
          _context45.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_CHANGE_BRAND, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context45.next = 17;
          break;
        case 13:
          _context45.prev = 13;
          _context45.t0 = _context45["catch"](0);
          _context45.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_CHANGE_BRAND, _context45.t0));
        case 17:
        case "end":
          return _context45.stop();
      }
    }, _callee45, null, [[0, 13]]);
  })();
}

/**
 * Editor Lock
 * @param payload
 * @returns api response
 * @description this function used to Editor Lock.
 * @description this function used to Editor Lock.
 */
function surveyEditorLock(_ref46) {
  var payload = _ref46.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
    var _response$data51, response;
    return _regeneratorRuntime().wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          _context46.prev = 0;
          _context46.next = 3;
          return (0, _effects.call)(_services.surveyEditorLockApi, payload);
        case 3:
          response = _context46.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data51 = response.data) === null || _response$data51 === void 0 ? void 0 : _response$data51.code) === 202)) {
            _context46.next = 9;
            break;
          }
          _context46.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context46.next = 11;
          break;
        case 9:
          _context46.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context46.next = 17;
          break;
        case 13:
          _context46.prev = 13;
          _context46.t0 = _context46["catch"](0);
          _context46.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_LOCK, _context46.t0));
        case 17:
        case "end":
          return _context46.stop();
      }
    }, _callee46, null, [[0, 13]]);
  })();
}

/**
 * Editor Lock Exist
 * @param payload
 * @returns api response
 * @description this function used to Editor Lock.
 * @description this function used to Editor Lock.
 */
function surveyEditorLockExist(_ref47) {
  var payload = _ref47.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
    var _response$data52, response;
    return _regeneratorRuntime().wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          _context47.prev = 0;
          _context47.next = 3;
          return (0, _effects.call)(_services.surveyEditorLockExistApi, payload);
        case 3:
          response = _context47.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data52 = response.data) === null || _response$data52 === void 0 ? void 0 : _response$data52.code) === 200)) {
            _context47.next = 9;
            break;
          }
          _context47.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_LOCK_EXIST, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context47.next = 11;
          break;
        case 9:
          _context47.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_LOCK_EXIST, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context47.next = 17;
          break;
        case 13:
          _context47.prev = 13;
          _context47.t0 = _context47["catch"](0);
          _context47.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_LOCK_EXIST, _context47.t0));
        case 17:
        case "end":
          return _context47.stop();
      }
    }, _callee47, null, [[0, 13]]);
  })();
}

/**
 * Editor Unlock
 * @param payload
 * @returns api response
 * @description this function used to Editor Unlock.
 * @description this function used to Editor Unlock.
 */
function surveyEditorUnlock(_ref48) {
  var payload = _ref48.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
    var _response$data53, response;
    return _regeneratorRuntime().wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          _context48.prev = 0;
          _context48.next = 3;
          return (0, _effects.call)(_services.surveyEditorUnlockApi, payload);
        case 3:
          response = _context48.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data53 = response.data) === null || _response$data53 === void 0 ? void 0 : _response$data53.code) === 202)) {
            _context48.next = 9;
            break;
          }
          _context48.next = 7;
          return (0, _effects.put)((0, _survey.surveySuccess)(_survey2.actionTypes.EDITOR_UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context48.next = 11;
          break;
        case 9:
          _context48.next = 11;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context48.next = 17;
          break;
        case 13:
          _context48.prev = 13;
          _context48.t0 = _context48["catch"](0);
          _context48.next = 17;
          return (0, _effects.put)((0, _survey.surveyError)(_survey2.actionTypes.EDITOR_UNLOCK, _context48.t0));
        case 17:
        case "end":
          return _context48.stop();
      }
    }, _callee48, null, [[0, 13]]);
  })();
}
var watchSurvey = function watchSurvey() {
  return /*#__PURE__*/_regeneratorRuntime().mark(function watch() {
    return _regeneratorRuntime().wrap(function watch$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          _context49.next = 2;
          return (0, _effects.takeLatest)(_survey2.actionTypes.GET_SURVEY_PASSCODE, surveyGetSurveyPasscode);
        case 2:
          _context49.next = 4;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LIST, surveyList);
        case 4:
          _context49.next = 6;
          return (0, _effects.takeLatest)(_survey2.actionTypes.FETCH, surveyFetch);
        case 6:
          _context49.next = 8;
          return (0, _effects.takeLatest)(_survey2.actionTypes.FETCH_PASSCODE, surveyFetchPasscode);
        case 8:
          _context49.next = 10;
          return (0, _effects.takeLatest)(_survey2.actionTypes.CREATE, surveyCreate);
        case 10:
          _context49.next = 12;
          return (0, _effects.takeLatest)(_survey2.actionTypes.UPDATE, surveyUpdate);
        case 12:
          _context49.next = 14;
          return (0, _effects.takeLatest)(_survey2.actionTypes.UPDATE_DETAIL, surveyUpdateDetail);
        case 14:
          _context49.next = 16;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LINKED_FUND, surveyLinkedFund);
        case 16:
          _context49.next = 18;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SAVE_LINKED_FUND, surveySaveLinkedFund);
        case 18:
          _context49.next = 20;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LOCK, surveyLock);
        case 20:
          _context49.next = 22;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LOCK_BULK, surveyLockBulk);
        case 22:
          _context49.next = 24;
          return (0, _effects.takeLatest)(_survey2.actionTypes.UNLOCK, surveyUnlock);
        case 24:
          _context49.next = 26;
          return (0, _effects.takeLatest)(_survey2.actionTypes.UNLOCK_BULK, surveyUnlockBulk);
        case 26:
          _context49.next = 28;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SOFT_DELETE, surveySoftDelete);
        case 28:
          _context49.next = 30;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SOFT_DELETE_BULK, surveySoftDeleteBulk);
        case 30:
          _context49.next = 32;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SUBMIT, surveySubmit);
        case 32:
          _context49.next = 34;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SUBMIT_BULK, surveySubmitBulk);
        case 34:
          _context49.next = 36;
          return (0, _effects.takeLatest)(_survey2.actionTypes.PAUSE, surveyPause);
        case 36:
          _context49.next = 38;
          return (0, _effects.takeLatest)(_survey2.actionTypes.PAUSE_BULK, surveyPauseBulk);
        case 38:
          _context49.next = 40;
          return (0, _effects.takeLatest)(_survey2.actionTypes.RESUME, surveyResume);
        case 40:
          _context49.next = 42;
          return (0, _effects.takeLatest)(_survey2.actionTypes.RESUME_BULK, surveyResumeBulk);
        case 42:
          _context49.next = 44;
          return (0, _effects.takeLatest)(_survey2.actionTypes.COPY_URL, surveyCopyUrl);
        case 44:
          _context49.next = 46;
          return (0, _effects.takeLatest)(_survey2.actionTypes.MAGIC_URL, surveyMagicUrl);
        case 46:
          _context49.next = 48;
          return (0, _effects.takeLatest)(_survey2.actionTypes.DOWNLOAD_ALL, surveyDownloadAll);
        case 48:
          _context49.next = 50;
          return (0, _effects.takeLatest)(_survey2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, surveyDownloadSurveyResponse);
        case 50:
          _context49.next = 52;
          return (0, _effects.takeLatest)(_survey2.actionTypes.UNIQUE_URL_EXTENSION, surveyUniqueUrlExtensionSg);
        case 52:
          _context49.next = 54;
          return (0, _effects.takeLatest)(_survey2.actionTypes.SOFT_DELETE_LIST, surveySoftDeleteList);
        case 54:
          _context49.next = 56;
          return (0, _effects.takeLatest)(_survey2.actionTypes.RESTORE, surveyRestore);
        case 56:
          _context49.next = 58;
          return (0, _effects.takeLatest)(_survey2.actionTypes.RESTORE_BULK, surveyRestoreBulk);
        case 58:
          _context49.next = 60;
          return (0, _effects.takeLatest)(_survey2.actionTypes.DELETE, surveyDelete);
        case 60:
          _context49.next = 62;
          return (0, _effects.takeLatest)(_survey2.actionTypes.DELETE_BULK, surveyDeleteBulk);
        case 62:
          _context49.next = 64;
          return (0, _effects.takeLatest)(_survey2.actionTypes.PREFIGHT, surveyPrefight);
        case 64:
          _context49.next = 66;
          return (0, _effects.takeLatest)(_survey2.actionTypes.IMPORT, surveyImport);
        case 66:
          _context49.next = 68;
          return (0, _effects.takeLatest)(_survey2.actionTypes.ERROR_SHEET_DOWNLOAD, surveyErrorSheetDownload);
        case 68:
          _context49.next = 70;
          return (0, _effects.takeLatest)(_survey2.actionTypes.ANALYTICS_SAVE, surveyAnalyticsSave);
        case 70:
          _context49.next = 72;
          return (0, _effects.takeLatest)(_survey2.actionTypes.ANALYTICS_GET, surveyAnalyticsGet);
        case 72:
          _context49.next = 74;
          return (0, _effects.takeLatest)(_survey2.actionTypes.ANALYTICS_UPDATE, surveyAnalyticsUpdate);
        case 74:
          _context49.next = 76;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LIST_CONFIGURATION, surveyListConfiguration);
        case 76:
          _context49.next = 78;
          return (0, _effects.takeLatest)(_survey2.actionTypes.FETCH_CONFIGURATION, surveyFetchConfiguration);
        case 78:
          _context49.next = 80;
          return (0, _effects.takeLatest)(_survey2.actionTypes.LIST_REVIEW_APPROVAL, surveyListReviewAndApprove);
        case 80:
          _context49.next = 82;
          return (0, _effects.takeLatest)(_survey2.actionTypes.APPROVE, surveyApprove);
        case 82:
          _context49.next = 84;
          return (0, _effects.takeLatest)(_survey2.actionTypes.APPROVE_BULK, surveyApproveBulk);
        case 84:
          _context49.next = 86;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_FETCH, surveyEditorFetch);
        case 86:
          _context49.next = 88;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_SAVE, surveyEditorSave);
        case 88:
          _context49.next = 90;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_CHANGE_BRAND, surveyEditorChangeBrand);
        case 90:
          _context49.next = 92;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_LOCK, surveyEditorLock);
        case 92:
          _context49.next = 94;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_LOCK_EXIST, surveyEditorLockExist);
        case 94:
          _context49.next = 96;
          return (0, _effects.takeLatest)(_survey2.actionTypes.EDITOR_UNLOCK, surveyEditorUnlock);
        case 96:
        case "end":
          return _context49.stop();
      }
    }, watch);
  });
};
function surveySaga() {
  return _regeneratorRuntime().wrap(function surveySaga$(_context50) {
    while (1) switch (_context50.prev = _context50.next) {
      case 0:
        _context50.next = 2;
        return (0, _effects.all)([(0, _effects.fork)(watchSurvey())]);
      case 2:
      case "end":
        return _context50.stop();
    }
  }, _marked);
}